export default __webpack_public_path__ + "static/media/mood_shock.cd1388f3.svg";